module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesRomantic.613ab5b.jpg";